import { render, staticRenderFns } from "./NormalSearchNav456.vue?vue&type=template&id=15f3aa92&scoped=true"
import script from "./NormalSearchNav456.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav456.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f3aa92",
  null
  
)

export default component.exports